
export default {
	permits: {},
	permitIds: [],
}